import React from "react"
import {IntegrationType} from "../types"
import {INTEGRATION_TYPE_INFO} from "../data/typeInfo"

interface IntegrationInfoBoxesProps {
  types: IntegrationType[]
}

const INFO_BOX_STYLES = {
  Authentication: {
    bgColor: "bg-blue-50",
    titleColor: "text-blue-900",
    textColor: "text-blue-700",
  },
  "HR & Directory": {
    bgColor: "bg-green-50",
    titleColor: "text-green-900",
    textColor: "text-green-700",
  },
  Messaging: {
    bgColor: "bg-purple-50",
    titleColor: "text-purple-900",
    textColor: "text-purple-700",
  },
  Storage: {
    bgColor: "bg-orange-50",
    titleColor: "text-orange-900",
    textColor: "text-orange-700",
  },
  "Call Center": {
    bgColor: "bg-teal-50",
    titleColor: "text-teal-900",
    textColor: "text-teal-700",
  },
}

export function IntegrationInfoBoxes({types}: IntegrationInfoBoxesProps) {
  const relevantTypes = types.filter((type) => type in INTEGRATION_TYPE_INFO)

  if (relevantTypes.length === 0) {
    return null
  }

  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3">
      {relevantTypes.map((type) => {
        const info = INTEGRATION_TYPE_INFO[type]
        const styles = INFO_BOX_STYLES[type as keyof typeof INFO_BOX_STYLES]
        return (
          <div key={type} className={`rounded-lg p-4 ${styles.bgColor}`}>
            <h3 className={`text-sm font-semibold ${styles.titleColor}`}>
              {info.name}
            </h3>
            <p className={`text-xs ${styles.textColor}`}>{info.description}</p>
          </div>
        )
      })}
    </div>
  )
}
